import { primaryColourMain } from 'app/agriculture/material';

export function Point() {
    return `
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="7" fill="${primaryColourMain}" stroke="#FFFFFF" stroke-width="2"/>
        </svg>
    `;
}
